import type React from 'react';

import { useUserTiming } from '@/core/observability/utils/useUserTiming';
import ReassuranceTitledList from '@/retention/Footer/modules/ReassuranceTitleList/ReassuranceTitledList';

export const Reassurance = () => {
  useUserTiming('homepageB2C/reassurance');

  return (
    <div id="reassuranceContainer" className="bg-foundation-inverted">
      <section className="mx-auto max-w-[1424px]">
        <ReassuranceTitledList />
      </section>
    </div>
  );
};
